import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const Component = lazy(() =>
  import(
    "@scenes/MessageComposition/EmailPreferenceCenter/EmailPreferenceCenterLibrary/EmailPreferenceCenterLibraryNRO"
  ).then((module) => ({
    default: module.EmailPreferenceCenterLibraryNRO,
  }))
);

export const usersPreferenceCentersNRO: NavigationRoutingObject = {
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("users-subscription-groups-preference-centers-nro-heading", "Email Preference Centers"),
  pageNameForTracking: () => "Email Preference Centers",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("preference-center-description-nav", "Create preference centers to help users manage communications"),
  icon: "preference-center",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return !featureOn("disable_custom_unsubscribe_and_preference_center_pages_in_ui");
  },
  shouldShowTertiaryNavigationCallback: ({ featureOn, hasPermission }) => {
    const granularPermissionsEnabled =
      featureOn("clip_granular_permissions_all") && featureOn("email_granular_permission_basic_read_only");
    if (granularPermissionsEnabled) {
      return hasPermission("appGroup", { permission: "viewPreferenceCenters" });
    }
    return true;
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  Component: Component,
  defaultRoute: "/users/subscription_groups/preference_centers/:appGroupId",
};
